// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-technical-documentation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-technical-documentation',
  title: 'Maintain AI technical documentation and user information',
  description:
    'Confirm that technical documentation is drawn up and maintained for each AI system (ISO/IEC 42001 Annex A.6.2.3, A.6.2.7, A.8.2), covering system purpose, intended use, performance metrics, data and model characteristics, known limitations, and operational constraints. Information provided to users and affected persons shall be clear, accessible and sufficient to allow appropriate use, oversight and challenge of outcomes. Review the AI technical-documentation template, a sample of completed documents, and the user-facing information provided with each AI system.',
  category: 'governance',
  scfIds: ['SCF-AIG-008'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI technical-documentation template is published' },
    { type: 'document-within-sla', description: 'Template review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
